type Props = { code: string };

function MobileApprovalActionIcon({ code }: Props) {
  code = code.toLowerCase();
  const symbol = code === 'submit' || code === 'urge'
    ? <path d="M16 23V9m-5 5 5-5 5 5" />
    : code === 'approve' || code === 'complete' || code === 'mark-read'
      ? <path d="m10 16 4 4 8-9" />
      : code === 'return' || code === 'withdraw'
        ? <path d="M22 12H11a5 5 0 0 0 0 10h3m-7-14-4 4 4 4" />
        : code === 'transfer'
          ? <path d="M8 12h14m-5-5 5 5-5 5M8 20h7" />
          : <path d="m11 11 10 10m0-10L11 21" />;

  return <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <circle cx="16" cy="16" r="14" fill="currentColor" />
    <g stroke="var(--icon-foreground, #fff)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">{symbol}</g>
  </svg>;
}

export default MobileApprovalActionIcon;
